
import { defineComponent } from "vue";

export default defineComponent({
  name: "Loader",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
});
